import { api } from './api';

export type TaskType = 'mandatory' | 'optional';
export type TaskStatus = 'pending' | 'completed' | 'ignored' | 'snoozed';

export interface Task {
  task_id: string;
  coach_id: string;
  task_type: TaskType;
  task_status: TaskStatus;
  task_priority: number;
  task_title: string;
  task_description: string;
  created_at: string;
  updated_at: string;
  completed_at?: string;
  due_date?: string;
  metadata?: {
    player_id?: string;
    player_name?: string;
    team_id?: string;
    [key: string]: unknown;
  };
}

export interface TasksMeta {
  total: number;
  mandatory_pending: number;
  optional_pending: number;
}

export const taskService = {
  async getTasks(): Promise<{ data: Task[]; meta: TasksMeta }> {
    const response = await api.get('/tasks');
    return response.data;
  },
};
